import { CodeBlock, monokai } from "react-code-blocks";
import { useOutletContext } from "react-router-dom";
import { TabNames } from "../Assets/variables";
import { useEffect } from "react";

const APIDefinitionCorporateActions = () => {
    const {setActiveTabItem} = useOutletContext();

    useEffect(() => {
        setActiveTabItem(TabNames.APIDefinition);
    }, []);

    return (
        <div id="tab-definition" class="api-panel">
            <div className="api-definition-container">
                <p className="bulk-paragraph">The Bulk API can be used for retrieving Corporate Actions, either with a full extract of data in minutes via the snapshot end point, or through regular calls to the <code>/update</code> end point, to retrieve the latest Corporate Actions.</p>
                <span className="bulk-heading-2 heading-2">Bulk API End Points</span>
                <table>
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>URL</th>
                            <th>Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Snapshot End Point</td>
                            <td><code>https://api.six-group.com/bulk/v1/corporateAction/snapshot</code></td>
                            <td>Use this endpoint to download a full weekly extract of Corporate Actions.</td>
                        </tr>
                        <tr>
                            <td>Update End Point</td>
                            <td><code>https://api.six-group.com/bulk/v1/corporateAction/update</code></td>
                            <td>Use this endpoint to download Corporate Actions deltas.</td>
                        </tr>
                    </tbody>
                </table>

                <span className="heading-2">Available Corporate Actions Datasets and End Points</span>
                <table>
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>URL</th>
                            <th>Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Equity And ETF Corporate Actions</td>
                            <td><code>https://api.six-group.com/bulk/v1/corporateAction/snapshot/../Equity</code></td>
                            <td>Only available for permissioned users.</td>
                        </tr>
                        <tr>
                            <td>Fixed Income Corporate Actions</td>
                            <td><code>https://api.six-group.com/bulk/v1/corporateAction/snapshot/../FixedIncome</code></td>
                            <td>Only available for permissioned users.</td>
                        </tr>
                    </tbody>
                </table>

                <span className="heading-2">Bulk API Optional URL Parameters</span>
                <p>The Bulk API <code>/update</code> URL can be adjusted either forwards or backwards by providing the <code>from</code> and <code>to</code> parameters, using ISO time format. For example:</p>
                <div className="code-example">
                    <CodeBlock
                        text={"…/update/…?from=2024-09-12T12:59:34.388Z&to=2024-09-12T15:59:34.388Z"}
                        language={"text"}
                        showLineNumbers={false}
                        startingLineNumber={1}
                        theme={monokai}
                        codeBlock={true}
                    />
                </div>
                <p>This will retrieve the updates between <code>2024-09-12T12:59:34.388Z</code> and <code>2024-09-12T15:59:34.388Z</code>. Ideally, when using the time parameters, URL format should be used.</p>

                <table>
                    <thead>
                        <tr>
                            <th>URL Parameter</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>from</td>
                            <td>
                                <p>Should typically be provided equal either to the timestamp <code>lastUpdated</code> of the latest snapshot which you downloaded or the time of your last query.</p>
                                <p>However, <code>from</code> can also be set to any prior time, as it simply provides the lower bound timestamp for the data presented.</p>
                            </td>
                        </tr>
                        <tr>
                            <td>to</td>
                            <td>
                                <p>Should typically be provided equal either to now or to some time since the last update, in order to throttle the amount of updates to download.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p>Note that the time difference between <code>from</code> and <code>to</code> should not exceed 7 days, otherwise an error will be thrown.</p>

                <span className="heading-2">Bulk API Data Life Cycle</span>

                <table>
                    <thead>
                        <tr>
                            <th>Event Description</th>
                            <th>Frequency</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Snapshot Creation Time</td>
                            <td>Every Friday evening or Saturday</td>
                        </tr>
                        <tr>
                            <td>Data Refresh Frequency</td>
                            <td>
                                <p>Fixed Income Corporate Actions are updated once a day, Monday to Friday</p>
                                <p>Equity & ETF Corporate Actions are updated every 15 minutes, Monday to Friday</p>
                            </td>
                        </tr>
                        <tr>
                            <td>Data Availability</td>
                            <td>Direct access to all data through Bulk API is removed 15 days after the data was first made available. Following the removal, On Demand Access is possible through support for 2,5 months after this 15-day period. In total, data should be accessible either directly or On Demand for 3 months after it was first made available via the Bulk API.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default APIDefinitionCorporateActions;
